import { BellIcon } from "@heroicons/react/24/outline";
import useGetUnseenCount from "./useGetUnseenCount";
import { useFetchNotifications } from "@novu/notification-center";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHasSharedContentNotification } from "./slice/getSharedContentNotification";

function CustomBell({ unseenCount: _unseenCount }: { unseenCount?: number }) {
  const [count] = useGetUnseenCount();
  const dispatch = useDispatch();

  const { data: notificationData } = useFetchNotifications();

  // useEffect(() => {
  //   if (count > 0) {
  //     refetchNotification();
  //   }
  // }, [count]);

  useEffect(() => {
    const notifications = notificationData?.pages?.[0]?.data || [];

    const hasSharedContent = notifications.some((notif: any) =>
      notif.content?.includes("has shared a")
    );

    if (hasSharedContent) {
      dispatch(setHasSharedContentNotification(true));
    }
  }, [notificationData, dispatch]);

  return (
    <div
      dir="rtl"
      className={
        location.pathname !== "/notifications"
          ? ""
          : "shadow-xl p-1 rounded-full bg-secondary/70"
      }
    >
      <BellIcon
        className={`relative size-8 ${location.pathname !== "/notifications" ? "" : "text-bkg"}`}
        aria-hidden="true"
      />
      {count > 0 && (
        <div
          aria-hidden="true"
          className={`absolute -start-2 -top-3 max-sm:top-2 max-sm:start-0 size-6 ring-2 ring-bkg dark:ring-secondary-bg text-center text-[10px] leading-4 font-medium bg-primary text-white rounded-full p-1 ${count > 99 && "w-8 -start-3"}`}
        >
          {count > 99 ? "+99" : count}
        </div>
      )}
      {count > 0 && (
        <span className="sr-only">
          {count > 99
            ? "More than 99 unread notifications"
            : `${count} unread notifications`}
        </span>
      )}
    </div>
  );
}

export default React.memo(CustomBell);
